import React from 'react';
import DownloadCard from './DownloadCard';

interface DownloadListProps {
  downloads: any[];
  loading: boolean;
  userEmail?: string;
}

export default function DownloadList({
  downloads,
  loading,
  userEmail,
}: DownloadListProps) {
  if (loading) return <p>Loading downloads...</p>;
  if (downloads.length === 0) return <p>No downloads found.</p>;

  return (
    <ul className="space-y-2">
      {downloads.map((d, idx) => (
        <DownloadCard key={idx} download={d} userEmail={userEmail} />
      ))}
    </ul>
  );
}
